<div class="div1" style="margin-top: 3%">
  <div class="section-heading">
    <h1 class="h2_font_size">Current Openings</h1>
    <div class="hr"></div>
  </div>
</div>
<h4 class="h4_style">
  Join our dynamic team and kickstart your career with 1 Bake Shop! We're a forward-thinking company dedicated to
  innovation and excellence.
  <br> Whether you're a seasoned professional or just starting out, we're committed to helping you grow and develop your
  skills.
  <br> Browse our current job openings and take your career to the next level.<br> Apply now and become a part of our
  talented team!
</h4>
<!-- Simple & Attractive Job Listings -->
<div *ngIf="showCareer" class="jobs-simple-container">
  <div class="jobs-simple-grid">
    <div *ngFor="let element of dataSource; let i = index" class="job-simple-card">

      <!-- Gradient Header with Position at Top, Date and Place in Line Below -->
      <div class="simple-header">
        <h3 class="header-title">Position : {{ element.position }}</h3>
        <span class="header-location">
          <span>Location : 📍</span> {{ element.place }}
        </span>
      </div>

      <!-- Description in Middle -->
      <div class="simple-description" [innerHTML]="element.description"></div>
      <span class="header-date">
        <span>Posted on : 📅</span> {{ element.modifiedDate | date: "dd MMM yyyy" }}
      </span>

      <!-- Apply Button at Bottom -->
      <div class="simple-footer">
        <button (click)="applayCareer(element, i)" class="simple-apply-btn">
          Apply Now <span>→</span>
        </button>
      </div>

    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="!dataSource?.length" class="simple-empty">
    <div>📋</div>
    <h3>No Openings Currently</h3>
    <p>Please check back later</p>
  </div>
</div>
<h4 style="text-align: center; margin-top: 20px">
  Work with us
</h4>
<section id="contact">
  <div class="container">
    <div class="row" id="contactRow">
      <div class="col-lg-7 col-md-7 text-center">
        <div class="form-style" id="contact_form">
          <form [formGroup]="createSetUpForm" (ngSubmit)="onCreateSetUpClick()">
            <div class="form-group">

              <div class="input-wrap">
                <input type="text" formControlName="name" required />
                <label>Name</label>
              </div>

              <div class="input-wrap">
                <input type="email" formControlName="email" required />
                <label>Email</label>
              </div>

              <div class="input-wrap">
                <input type="number" formControlName="phone" pattern="[6-9][0-9]{9}" required />
                <label>Mobile No</label>
              </div>

              <div class="input-wrap">
                <input type="text" formControlName="position" required />
                <label>Position</label>
              </div>

              <div class="input-wrap">
                <input type="text" formControlName="place" required />
                <label>Place</label>
              </div>

              <input hidden type="file" #fileUploader (change)="handleFileInput($any($event.target).files)"
                accept="application/pdf" required />

              <div class="input-wrap">
                <input formControlName="documentPath" (click)="fileUploader.click()" value="{{ uploadedFileName }}"
                  required />
                <label>Upload CV</label>
              </div>

              <a class="btn" id="submit_btn">
                <div class="btn-line"></div>
                <button type="submit" class="btn-line btn-line-shift" style="background-color: #d0324b; color: white">
                  Submit
                </button> Send Message
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>